import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./styles/DataAnalytics.css";
import App from "./components/App";
import reportWebVitals from "./reportWebVitals";
import { Provider, useDispatch } from "react-redux";
import store from "./store";
import { CircularProgress } from "@mui/material";
import axiosInstance from "./services/axiosInstance";

const Index = () => {
    const [authStatus, setAuthStatus] = useState(null);
    const [authData, setAuthData] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchAuthData = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const token = urlParams.get("token");

            if (token) {
                localStorage.setItem("accessToken", token);
                axiosInstance.defaults.headers.common["Authorization"] = token;
            }

            const accessToken = localStorage.getItem("accessToken");
            if (!accessToken) {
                setAuthStatus(401);
                return;
            }

            try {
                const response = await axiosInstance.post('/api/token_auth/me', null, {
                    headers: {
                        'Authorization': accessToken
                    }
                });
                if (response.data.authStatus === "authenticated") {
                    setAuthStatus(200);
                    setAuthData(response.data);
                    if (response.data?.user_info?.userId) {
                        localStorage.setItem("userId", response.data.user_info.userId);
                        dispatch({ type: "SET_USER", payload: response.data.user_info });
                    }
                } else {
                    setAuthStatus(401);
                }
            } catch (error) {
                console.error("Error fetching auth data:", error);
                setAuthStatus(401);
            }
        };
        fetchAuthData();
    }, [dispatch]);

    if (authStatus === null) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100vw",
                    height: "100vh",
                }}
            >
                <CircularProgress style={{ color: "blue" }} />
            </div>
        );
    }

    if (authStatus === 401) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100vw",
                    height: "100vh",
                    flexDirection: "column",
                    gap: "20px",
                }}
            >
                <h2 style={{ color: "red" }}>Invalid Token</h2>
                <p>The provided authentication token is incorrect or expired.</p>
            </div>
        );
    }

    return (
        <React.StrictMode>
            <App authStatus={authStatus} authData={authData} />
        </React.StrictMode>
    );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        <Index />
    </Provider>
);

reportWebVitals();